import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/* =====================================================
    🔧 cn — usado por TODOS os componentes UI
   ===================================================== */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/* =====================================================
    🖼️ MEDIA — O Tradutor de Links (RESOLVE O 404)
   ===================================================== */
export const MEDIA = (path) => {
  if (!path) return null;
  
  // Se já for um link completo (YouTube ou outro site), não mexe
  if (path.startsWith('http')) return path; 
  
  // Remove a barra inicial se existir para não duplicar
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;

  // Aponta para o seu servidor real no Render
  return `https://backend-empregos.onrender.com/${cleanPath}`;
};

/* =====================================================
    💰 SALÁRIO
   ===================================================== */
export function formatSalary(min, max) {
  if (!min && !max) return "Salário a combinar";

  const formatter = (v) =>
    Number(v).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 0,
    });

  if (min && max && min !== max) {
    return `${formatter(min)} – ${formatter(max)}`;
  }

  return formatter(min || max);
}

/* =====================================================
    📅 DATA
   ===================================================== */
export function formatDate(date) {
  if (!date) return "";

  return new Date(date).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

/* =====================================================
    🏢 MODALIDADE
   ===================================================== */
export function getModalityLabel(modality) {
  const map = {
    presencial: "Presencial",
    remoto: "Remoto",
    hibrido: "Híbrido",
  };

  return map[modality] || modality;
}